import type { ReactNode } from 'react'
import '@/landing/landing.css'
import { SiteFooter, SiteHeader } from './chrome'

/** Header and footer of the public pages. `children` is the page's
 * <main id="main">. */
export function SiteShell({ children }: { children: ReactNode }) {
  return (
    <div className="lp">
      <a href="#main" className="lp-skip">До змісту</a>
      <SiteHeader />
      {children}
      <SiteFooter />
    </div>
  )
}
